import React from "react";
import { Fragment } from "react";

export default function EditShoppingSubHeader() {
  return (
    <Fragment>
      <div className="row customers shoppingHeader insideAdd">
        <h2 className="eidtShopping">Add Part/Chemical/Others</h2>
      </div>
    </Fragment>
  );
}
